import React from 'react';
import { X, Smartphone, Share2, PlusSquare, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const WelcomeModal = ({ isOpen, onClose, userName }) => {
  if (!isOpen) return null;

  // Detect platform
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 relative animate-in fade-in slide-in-from-bottom-4 duration-300">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={24} />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-minted-100 rounded-full mb-4">
            <Smartphone className="text-minted-600" size={32} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Welcome to Minted, {userName}! 🎉
          </h2>
          <p className="text-gray-600">
            Get the full app experience by adding Minted to your home screen
          </p>
        </div>

        {/* Install Instructions */}
        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          {isIOS ? (
            <>
              <h3 className="font-semibold text-gray-900 mb-3">For iPhone/iPad:</h3>
              <ol className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">1.</span>
                  <span>Tap the <Share2 size={16} className="inline mx-1" /> Share button at the bottom of Safari</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">2.</span>
                  <span>Scroll down and tap "Add to Home Screen"</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">3.</span>
                  <span>Tap "Add" in the top right corner</span>
                </li>
              </ol>
            </>
          ) : isAndroid ? (
            <>
              <h3 className="font-semibold text-gray-900 mb-3">For Android:</h3>
              <ol className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">1.</span>
                  <span>Tap the menu (⋮) in Chrome</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">2.</span>
                  <span>Select "Add to Home screen" or "Install app"</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold min-w-5">3.</span>
                  <span>Tap "Install" or "Add"</span>
                </li>
              </ol>
            </>
          ) : (
            <>
              <h3 className="font-semibold text-gray-900 mb-3">Install the app:</h3>
              <p className="text-sm text-gray-700">
                Look for the install prompt or menu option to add Minted to your device!
              </p>
            </>
          )}
        </div>

        {/* App Features */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-900 mb-3">What you can do:</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-center gap-2">
              <CheckCircle className="text-minted-500 flex-shrink-0" size={18} />
              <span>Browse & buy pre-loved fashion items</span>
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="text-minted-500 flex-shrink-0" size={18} />
              <span>List your own items to sell</span>
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="text-minted-500 flex-shrink-0" size={18} />
              <span>Chat directly with buyers & sellers</span>
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="text-minted-500 flex-shrink-0" size={18} />
              <span>Get instant notifications on new messages & offers</span>
            </li>
          </ul>
        </div>

        <Button
          onClick={onClose}
          className="w-full bg-minted-500 hover:bg-minted-600 text-white"
        >
          Got it, let's explore!
        </Button>

        <p className="text-xs text-gray-500 text-center mt-4">
          Check your email for more tips and updates!
        </p>
      </div>
    </div>
  );
};

export default WelcomeModal;
